import React, { forwardRef, useContext, useLayoutEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { PopoverContext } from './PopoverContext';
import { getLeftPosition } from './utils';
import { PopoverContentContainer } from './styles/popover.styled';
const PopoverContent = forwardRef(({ children, dataTest }, ref) => {
    const [left, setLeft] = useState(0);
    const { direction, contentTop, contentBottom, triggerLeft, triggerRight, offset, setShowFade } = useContext(PopoverContext);
    const contentContainerRef = useRef(null);
    useLayoutEffect(() => {
        if (!contentContainerRef.current) {
            return () => { };
        }
        const windowWidth = window.innerWidth;
        const contentContainer = contentContainerRef.current;
        const resizeObserver = new ResizeObserver(() => {
            handleShowFade(contentContainer);
        });
        resizeObserver.observe(contentContainer);
        window.requestAnimationFrame(() => {
            const { width: contentElementWidth } = contentContainer.getBoundingClientRect();
            const popoverContentLeftPosition = getLeftPosition({
                windowWidth,
                contentElementWidth,
                triggerLeft,
                triggerRight,
            });
            setLeft(popoverContentLeftPosition);
        });
        return () => {
            resizeObserver.disconnect();
        };
    }, [triggerRight, triggerLeft]);
    const handleShowFade = (node) => {
        const { scrollHeight, scrollTop, clientHeight } = node;
        setShowFade(scrollHeight - Math.ceil(scrollTop) > clientHeight);
    };
    return (React.createElement("div", { ref: ref, "data-test": dataTest },
        React.createElement(PopoverContentContainer, { "$direction": direction, top: contentTop, bottom: contentBottom, left: left, ref: contentContainerRef, offset: offset, onScroll: (event) => {
                handleShowFade(event.target);
            } }, children)));
});
PopoverContent.displayName = 'PopoverContent';
export default PopoverContent;
//# sourceMappingURL=PopoverContent.js.map